/*
 * Fairybell "Houd me op de hoogte" (Klaviyo Back in Stock).
 * Leest product + variant pas bij het klikken uit de pagina, zodat het altijd klopt,
 * ook nadat de klant zonder herladen naar een ander product is gewisseld.
 */
(function () {
  var cfgNode = document.getElementById('FairybellBisConfig');
  if (!cfgNode) return;
  var cfg;
  try { cfg = JSON.parse(cfgNode.textContent); } catch (e) { return; }
  if (!cfg.companyId) return;

  var ICON_BELL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.7 21a2 2 0 0 1-3.4 0"/></svg>';
  var ICON_CLOSE = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var ICON_LOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';
  var ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var root = document.createElement('div');
  root.className = 'fb-bis';
  root.hidden = true;
  root.innerHTML =
    '<div class="fb-bis__backdrop" data-fb-bis-close></div>' +
    '<div class="fb-bis__dialog" role="dialog" aria-modal="true" aria-labelledby="FbBisTitle">' +
      '<div class="fb-bis__head">' +
        '<span class="fb-bis__bell">' + ICON_BELL + '</span>' +
        '<h2 class="fb-bis__title" id="FbBisTitle">' + esc(cfg.heading) + '</h2>' +
        '<button type="button" class="fb-bis__close" data-fb-bis-close aria-label="' + esc(cfg.close) + '">' + ICON_CLOSE + '</button>' +
      '</div>' +
      '<div class="fb-bis__body">' +
        '<div class="fb-bis__product">' +
          '<img class="fb-bis__thumb" alt="" width="84" height="84">' +
          '<div><p class="fb-bis__name"></p><span class="fb-bis__status"></span></div>' +
        '</div>' +
        '<form class="fb-bis__form" novalidate>' +
          '<p class="fb-bis__intro">' + esc(cfg.intro) + '</p>' +
          '<label class="fb-bis__label" for="FbBisEmail">' + esc(cfg.emailLabel) + '</label>' +
          '<input class="fb-bis__input" id="FbBisEmail" type="email" name="email" autocomplete="email" inputmode="email" required>' +
          '<p class="fb-bis__message" role="alert"></p>' +
          '<button type="submit" class="fb-bis__submit">' + esc(cfg.button) + '</button>' +
          '<p class="fb-bis__privacy">' + ICON_LOCK + esc(cfg.privacy) + '</p>' +
        '</form>' +
        '<div class="fb-bis__success" aria-live="polite">' +
          '<div class="fb-bis__check">' + ICON_CHECK + '</div>' +
          '<p class="fb-bis__success-title">' + esc(cfg.successTitle) + '</p>' +
          '<p>' + esc(cfg.success) + '</p>' +
        '</div>' +
      '</div>' +
    '</div>';

  var els = {};
  var current = null;
  var lastFocus = null;

  function mount() {
    if (root.isConnected) return;
    document.body.appendChild(root);
    els.name = root.querySelector('.fb-bis__name');
    els.status = root.querySelector('.fb-bis__status');
    els.thumb = root.querySelector('.fb-bis__thumb');
    els.form = root.querySelector('.fb-bis__form');
    els.input = root.querySelector('.fb-bis__input');
    els.msg = root.querySelector('.fb-bis__message');
    els.submit = root.querySelector('.fb-bis__submit');
    els.form.addEventListener('submit', onSubmit);
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-fb-bis-close]')) close();
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') trapFocus(e);
    });
  }

  function trapFocus(e) {
    var f = root.querySelectorAll('button:not([disabled]), input:not([disabled])');
    var list = Array.prototype.filter.call(f, function (n) { return n.offsetParent !== null; });
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  // Product en variant uit de pagina zoals die NU is (na eventueel wisselen van product).
  function readProduct(trigger) {
    var scope = trigger.closest('product-info') || document.querySelector('product-info[id^="MainProduct"]') || document;
    var idInput =
      (trigger.closest('.product-form__buttons') && trigger.closest('.product-form__buttons').parentNode.querySelector('input[name="id"]')) ||
      scope.querySelector('form[data-type="add-to-cart-form"] input[name="id"]') ||
      scope.querySelector('input[name="id"]');
    var variantId = idInput && idInput.value;
    if (!variantId) {
      try { variantId = new URL(window.location.href).searchParams.get('variant'); } catch (e) {}
    }
    var titleEl = scope.querySelector('.product__title');
    var statusEl = scope.querySelector('.product__inventory');
    var img = scope.querySelector('.product__media-item.is-active img') || scope.querySelector('.product__media-item img');
    var imgSrc = img ? (img.currentSrc || img.src || '') : '';
    if (imgSrc.indexOf('data:') === 0) imgSrc = '';
    return {
      variantId: variantId,
      title: titleEl ? titleEl.textContent.trim() : document.title,
      status: statusEl ? statusEl.textContent.replace(/\s+/g, ' ').trim() : '',
      image: imgSrc
    };
  }

  function sized(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  // Echte productfoto van het product (of de variant) waarop de klant zich inschrijft.
  // De URL is na het wisselen van product al bijgewerkt, dus /products/<handle>.js klopt altijd.
  function loadProductImage(info) {
    var path = window.location.pathname.replace(/\/$/, '');
    if (path.indexOf('/products/') === -1) return;
    fetch(path + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || current !== info) return;
        var v = (p.variants || []).filter(function (x) { return String(x.id) === String(info.variantId); })[0];
        var src = (v && v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]);
        if (src) { els.thumb.src = sized(src, 200); els.thumb.hidden = false; }
        if (p.title && !info.title) els.name.textContent = p.title;
      })
      .catch(function () {});
  }

  function open(trigger) {
    mount();
    current = readProduct(trigger);
    lastFocus = trigger;
    root.classList.remove('is-done');
    els.name.textContent = current.title;
    els.status.textContent = current.status;
    if (current.image) { els.thumb.src = current.image; els.thumb.hidden = false; } else { els.thumb.hidden = true; }
    loadProductImage(current);
    els.msg.textContent = '';
    els.input.removeAttribute('aria-invalid');
    els.submit.disabled = false;
    els.submit.textContent = cfg.button;
    root.hidden = false;
    document.body.classList.add('fb-bis-open');
    setTimeout(function () { els.input.focus(); }, 50);
  }

  function close() {
    root.hidden = true;
    document.body.classList.remove('fb-bis-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onSubmit(e) {
    e.preventDefault();
    var email = els.input.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      els.input.setAttribute('aria-invalid', 'true');
      els.msg.textContent = cfg.invalid;
      els.input.focus();
      return;
    }
    if (!current || !current.variantId) { els.msg.textContent = cfg.error; return; }
    els.input.removeAttribute('aria-invalid');
    els.msg.textContent = '';
    els.submit.disabled = true;
    els.submit.textContent = cfg.sending;

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(cfg.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + current.variantId } }
          }
        }
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Klaviyo ' + r.status);
        root.classList.add('is-done');
        root.querySelector('.fb-bis__close').focus();
      })
      .catch(function (err) {
        console.warn('[Fairybell BIS]', err);
        els.msg.textContent = cfg.error;
        els.submit.disabled = false;
        els.submit.textContent = cfg.button;
      });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.klaviyo-bis-trigger');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    open(trigger);
  }, true);
})();
